import ParameterErrors from '../errors/ParameterErrors';
import Vector2 from '../geometry/Vector2';
import Location from '../modelling/Location';
import UrlHelper from '../core/UrlHelper';
import Urls from '../urls/Urls';
import PlotStatus from './PlotStatus';
import HouseTypes from './HouseTypes';
import RoomType from './RoomType';
import eventEnable from '../core/eventEnable';
import Handles from '../core/Handles';
import enableAcceptBindings from '../mvvm/enableAcceptBindings';
import exposeBinding from '../mvvm/exposeBinding';
import SiteJsonUnitBirdsEyeViews from '../site/SiteJsonUnitBirdsEyeViews';
import SiteJsonUnitPlot from '../site/SiteJsonUnitPlot';
import SiteJsonFileUnitNearestOutside360Move from '../site/SiteJsonFileUnitNearestOutside360Move';
import DynamicImage from '../images/DynamicImage';
import numberWithCommas from '../core/numberWithCommas';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class SiteJsonUnit{
	constructor(props){
		eventEnable(this);
		enableAcceptBindings(this);
		const {id, name, birdsEyeViews, useFrontViewInsteadOfStreetView,
			selected, threeDNodes, nearestOutside360Move, plots, frontViewImage, streetViewImage}=props;
		
		if(id===undefined||id===null)
			throwNotProvided('id');
		
		/*if(name===undefined||name===null)
			throwNotProvided('name');*/
		
		if(birdsEyeViews===undefined||birdsEyeViews===null)
			throwNotProvided('birdsEyeViews');
		
		/*if(frontViewImageRelativePath===undefined || frontViewImageRelativePath===null)
			throwNotProvided('frontViewImageRelativePath');*/
		
		if(plots===undefined||plots===null)
			throwNotProvided('plots');
		
		
		this._hash = `unit_${id}`;
		this._id = id;
		this._name = name;
		this._birdsEyeViews = birdsEyeViews;
		this._nearestOutside360Move = nearestOutside360Move;
		this._threeDNodes = threeDNodes;
		this._selected = selected?true:false;
		this._plots = plots.sort(function(plotA, plotB){return plotA.number - plotB.number});
		this._plotSelectedChanged=this._plotSelectedChanged.bind(this);
		this._plots.forEach(plot=>plot.addEventListener('selectedChanged', this._plotSelectedChanged));
		this._frontViewImage=frontViewImage;
		this._streetViewImage= streetViewImage;
		this._useFrontViewInsteadOfStreetView= useFrontViewInsteadOfStreetView;
		this._dispatchActiveChanged=this._dispatchActiveChanged.bind(this);
		this._handleActiveHandlesChange=this._handleActiveHandlesChange.bind(this);
		this._activeHandles = new Handles();
		this._activeHandles.addEventListener('change', this._handleActiveHandlesChange);
		this.getBirdsEyeViewMarkerPositionForBirdsEyeViewWithAngle = this.getBirdsEyeViewMarkerPositionForBirdsEyeViewWithAngle.bind(this);
		this.getBirdsEyeViewMarkerPositionForBirdsEyeViewWithIndex = this.getBirdsEyeViewMarkerPositionForBirdsEyeViewWithIndex.bind(this);
		exposeBinding(this, 'selected', ()=>this.selected);
	}
	_plotSelectedChanged(){
		this.bindingsHandler.changed('selected', this.selected);
	}
	get frontViewImage(){
		return this._frontViewImage;
	}
	get streetViewImage(){
		return this._streetViewImage;
	}
	get useFrontViewInsteadOfStreetView(){
		return this._useFrontViewInsteadOfStreetView;
	}
	get nearestOutside360Move(){
		return this._nearestOutside360Move;
	}
	get threeDNodes(){
		return this._threeDNodes;
	}
	get hash(){
	    return this._hash;
	}
	get id(){
		return this._id;
	}
	get selected(){
		return this._plots.filter(plot=>plot.selected).length>0;
	}
	get plots(){
		return this._plots;
	}
	get allPlotsAffordable(){
		for(var i=0; i<this._plots.length; i++){
			if(!this._plots[i].affordable)return false;
		}
		return true;
	}
	get hasMoreThanOnePlot(){
		return this._plots.length>1;
	}
	/*
	set selected(value){
		const oldValue = this._selected;
		this._selected = value;
		if(oldValue!==value){
			this.bindingsHandler.changed('selected', value);
		}
	}*/
	get active(){
		return this._activeHandles.taken;
	}
	takeActiveHandle(){
		return this._activeHandles.take();
	}
	getBirdsEyeViewMarkerPositionForBirdsEyeViewWithAngle(angle){
		return this._birdsEyeViews.getMarkerPositionForBirdsEyeViewWithAngle(angle);
	}
	getBirdsEyeViewMarkerPositionForBirdsEyeViewWithIndex(index){
		return this._birdsEyeViews.getBirdsEyeViewMarkerPositionForBirdsEyeViewWithIndex(index);
	}
	_dispatchActiveChanged(){
		this.dispatchEvent({type:'active', active:this.active});
	}
	_handleActiveHandlesChange(e){
		this._dispatchActiveChanged();
	}
	static fromJSON(jObject, houseTypes, currencyConfiguration){
		let unit = null;
		const getUnit=()=>unit;
		const plots = jObject.plots.map(plot=>SiteJsonUnitPlot.fromJSON(plot, houseTypes, currencyConfiguration, getUnit));
		unit=new SiteJsonUnit({
			id:jObject.id,
			name:jObject.name, 
			birdsEyeViews:SiteJsonUnitBirdsEyeViews.fromJSON(jObject.birdsEyeViews),
			frontViewImage:jObject.frontViewImage?DynamicImage.fromJSON(jObject.frontViewImage):null,
			streetViewImage:jObject.streetViewImage?DynamicImage.fromJSON(jObject.streetViewImage):null,
			useFrontViewInsteadOfStreetView:jObject.useFrontViewInsteadOfStreetView,
			nearestOutside360Move:jObject.nearestOutside360Move?SiteJsonFileUnitNearestOutside360Move.fromJSON(jObject.nearestOutside360Move):null,
			plots:plots,
			threeDNodes:jObject.threeDNodes
		});
		return unit;
	}
	
}